import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  chatMain: {
    display: 'flex',
    flex: "1",
  },
  chatWrap: {
    display: 'flex',
    padding: '15px 0px',
    width: "100%",
    '& .chat-iframe': {
      border: "0",
      width: '100%',
      pointerEvents: "all",
    },
  },
  hidden: {
    display: 'none',
  }
}));